import { z } from "zod";
import { documentoRelacionadoSchema, facturaBaseSchema, emisorBaseSchema } from "./common.schema";

export const resumenNceSchema = z
  .object({
    totalNoSuj: z.number().default(0),
    totalExenta: z.number().default(0),
    totalGravada: z.number().default(0),
    subTotalVentas: z.number().default(0),
    descuNoSuj: z.number().default(0),
    descuExenta: z.number().default(0),
    descuGravada: z.number().default(0),
    totalDescu: z.number().default(0),
    tributos: z
      .array(
        z.object({
          codigo: z.string(),
          descripcion: z.string(),
          valor: z.number(),
        })
      )
      .default([]),
    subTotal: z.number().default(0),
    ivaPerci1: z.number().default(0),
    ivaRete1: z.number().default(0),
    reteRenta: z.number().default(0),
    montoTotalOperacion: z.number().default(0),
    totalLetras: z.string().default(""),
    condicionOperacion: z.number().default(1),
  })
  .strip();

export const facturaNceSchema = facturaBaseSchema
  .extend({
    documentoRelacionado: documentoRelacionadoSchema.nullable().superRefine((val, ctx) => {
      if (val === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "El campo documento relacionado no puede quedar vacio.",
        });
        return;
      }

      if (val.length < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Debes incluir al menos un documento relacionado.",
        });
      }

      if (val.length > 50) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "No puedes incluir más de 50 documentos relacionados.",
        });
      }
    }),
    resumen: resumenNceSchema,
    emisor: emisorBaseSchema.omit({ codEstableMH: true, codPuntoVentaMH: true, codEstable: true, codPuntoVenta: true }).strip(),
  })
  .strip();
